import {FileDownloaderFactoryService} from "@feature/_app_modules/composite-details/services/file-downloader-factory.service";
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'downloadable-noticeboard-attachment',
  templateUrl: './downloadable-noticeboard-attachment.component.html'
})
export class DownloadableNoticeboardAttachmentComponent implements OnInit {

    /**
     * Gets or sets a number indicating the uri of the file in document centre
     */
    @Input() uri : number;

    /**
     * Gets or sets the display name of the file to be downloaded.
     */
    @Input() displayName : string;

    getDownloader() {
      return this.downloaderFactory.getNoticeboardAttachmentDownloader(this.uri);
    }

    ngOnInit(): void { }

    constructor(private readonly downloaderFactory : FileDownloaderFactoryService) {
    }
}
